import type { AddOnRequest, AddOnRequestResponse } from "@classes-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { learningServiceRequest } from "@/services/utils";
import { QUERY_KEY } from "./useGetAddOnRequests";

export const useUnarchiveAddOnRequest = (useMutationOptions?: UseMutationOptions<AddOnRequest, Error, string>) => {
  const queryClient = useQueryClient();

  return useMutation<AddOnRequest, Error, string>({
    mutationFn: async (addOnRequestId: string) => {
      const response: AxiosResponse<AddOnRequestResponse> = await learningServiceRequest({
        method: "put",
        url: `/add_ons/request/unarchive/${addOnRequestId}/`,
      });
      return response.data.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
    ...useMutationOptions,
  });
};
